
<ng-container *ngIf="!isLoged">
	<app-login-form [loginErrorMsgName]="SSOError" (LoginEvent)="FillListItems($event)">
	</app-login-form>
</ng-container>

<ng-container *ngIf="isLoged && listItems">
	<app-select-buform [listItems]="listItems" [creds]="creds" [Displayedpassword]="Displayedpassword"
		(ReturnToLogin)="Return2Login()">
	</app-select-buform>
</ng-container>

<footer>
	<img src="assets/images/bi-logo.png" alt="" srcset="">
	<span>{{'AllRightsReservedVersion' | translate}}: {{_appVersion}}
	</span>
</footer>
